export class PuntoTipo {

    idTipo: number;
    descripcion: string;

    constructor(data: any) {
        this.idTipo = data['id'];
        this.descripcion = data['descripcion'];
    }

}